<ion-content class="ion-padding">
  <div >

    <h3 class="ion-text-center"> Terms & Conditions</h3>


    <b>OVERVIEW</b>
    <p>The XClub has been curated for you by vivo Mobile India Private Limited (hereinafter referred to as vivo) and
      powered by Club Concierge Services (India) Private Limited (herein after referred to as "CC"). Throughout the app,
      the terms “we”, “us” and “our” refer to Club Concierge Services Private Limited and its partners and affiliates.
      vivo along with CC offers this app, including all information, tools and services available from this app to you,
      the user, conditioned upon your acceptance of all terms, conditions, policies and notices stated here below. By
      downloading and using our app and/ or purchasing something from us, you engage in our “Service” and agree to be
      bound by the following terms and conditions (“Terms of Service”, “Terms”), including those additional terms and
      conditions and policies referenced herein and/or available by hyperlink. These Terms of Service apply to all users
      of the app, including without limitation users who are browsers, vendors, customers, merchants, and/ or
      contributors
      of content. Please read these Terms of Service carefully before accessing or using our app. By accessing or using
      any part of the app, you agree to be bound by these Terms of Service. If you do not agree to all the terms and
      conditions of this agreement, then you may not access the app or use any services. If these Terms of Service are
      considered an offer, acceptance is expressly limited to these Terms of Service. Any new features or tools which
      are
      added to the current store shall also be subject to the Terms of Service. You can review the most current version
      of
      the Terms of Service at any time on this page. We reserve the right to update, change or replace any part of these
      Terms of Service by posting updates and/or changes to our app. It is your responsibility to check this page
      periodically for changes. Your continued use of or access to the app following the posting of any changes
      constitutes acceptance of those changes. </p>

    <b>ONLINE APP TERMS</b>
    <p>By agreeing to these Terms of Service, you represent that you are at least the age of majority in your state or
      province of residence, or that you are the age of majority in your state or province of residence, and you have
      given us your consent to allow any of your minor dependents to use this app. You may not use our products for any
      illegal or unauthorized purpose nor may you, in the use of the Service, violate any laws in your jurisdiction
      (including but not limited to copyright laws). You must not transmit any worms or viruses or any code of a
      destructive nature. A breach or violation of any of the Terms will result in an immediate termination of your
      Membership.</p>
    <b>GENERAL CONDITIONS</b>
    <p>We reserve the right to refuse service to anyone for any reason at any time. You understand that your content
      (not
      including credit card information), may be transferred unencrypted and involve (a) transmissions over various
      networks; and (b) changes to conform and adapt to technical requirements of connecting networks or devices. Credit
      card information is always encrypted during transfer over networks. You agree not to reproduce, duplicate, copy,
      sell, resell or exploit any portion of the Service, use of the Service, or access to the Service or any contact on
      the app through which the service is provided, without express written permission by us. The headings used in this
      agreement are included for convenience only and will not limit or otherwise affect these Terms.</p>
    <b>ACCURACY, COMPLETENESS AND TIMELINESS OF INFORMATION</b>
    <p>
      We are not responsible if information made available on this app is not accurate, complete or current. The
      material
      on this app is provided for general information only and should not be relied upon or used as the sole basis for
      making decisions without consulting primary, more accurate, more complete or more timely sources of information.
      Any
      reliance on the material on this app is at your own risk. This app may contain certain historical information.
      Historical information, necessarily, is not current and is provided for your reference only. We reserve the right
      to
      modify the contents of this app at any time, but we have no obligation to update any information on our app. You
      agree that it is your responsibility to monitor changes to our app

    </p>
    <b>MODIFICATIONS TO THE SERVICE AND PRICES</b>
    <p>Prices for our products and services are subject to change without notice. We reserve the right at any time to
      modify or discontinue the Service (or any part or content thereof) without notice at any time. We shall not be
      liable to you or to any third-party for any modification, price change, suspension or discontinuance of the
      Service.
    </p>



    <b>PRODUCTS OR SERVICES (IF APPLICABLE)</b>
    <p>Certain products or services may be available exclusively online through the app. These products or services may
      have limited quantities and are subject to return or exchange only according to our Return Policy. We have made
      every effort to display as accurately as possible the colours and images of our products that appear at the store.
      We cannot guarantee that your phone screen’s display of any colour will be accurate. We reserve the right, but are
      not obligated, to limit the sales of our products or Services to any person, geographic region or jurisdiction. We
      may exercise this right on a case-by-case basis. We reserve the right to limit the quantities of any products or
      services that we offer. All descriptions of products or product pricing are subject to change at any time without
      notice, at the sole discretion of us. We reserve the right to discontinue any privilege, product or service at any
      time. Any offer for any product or service made on this app is void where prohibited. We do not warrant that the
      quality of any products, services, information, or other material purchased or obtained by you will meet your
      expectations, or that any errors in the Service will be corrected.
    </p>
    <b>ACCURACY OF BILLING AND ACCOUNT INFORMATION </b>
    <p>
      We reserve the right to refuse any order you place with us. We may, in our sole discretion, limit or cancel
      quantities purchased per person, per household or per order. These restrictions may include orders placed by or
      under the same customer account, the same credit card, and/or orders that use the same billing and/or shipping
      address. In the event that we make a change to or cancel an order, we may attempt to notify you by contacting the
      e-mail and/or billing address/phone number provided at the time the order was made. We reserve the right to limit
      or
      prohibit orders that, in our sole judgment, appear to be placed by dealers, resellers or distributors. You agree
      to
      provide current, complete and accurate purchase and account information for all purchases made on our app. You
      agree
      to promptly update your account and other information, including your email address and credit card numbers and
      expiration dates, so that we can complete your transactions and contact you as needed. For more detail, please
      review our Returns Policy.
    </p>
    <b>OPTIONAL TOOLS </b>
    <p>
      We may provide you with access to third-party tools over which we neither monitor nor have any control nor input.
      You acknowledge and agree that we provide access to such tools “as is” and “as available” without any warranties,
      representations or conditions of any kind and without any endorsement. We shall have no liability whatsoever
      arising
      from or relating to your use of optional third-party tools. Any use by you of optional tools offered through the
      app
      is entirely at your own risk and discretion and you should ensure that you are familiar with and approve of the
      terms on which tools are provided by the relevant third-party provider(s). We may also, in the future, offer new
      services and/or features through the app (including, the release of new tools and resources). Such new features
      and/or services shall also be subject to these Terms of Service.
    </p>
    <b>THIRD-PARTY LINKS </b>
    <p>
      Certain content, products and services available on our app and via our Service may include materials from third
      parties. Third-party links on this app may direct you to third-party apps and/or websites that are not affiliated
      with us. We are not responsible for examining or evaluating the content or accuracy and we do not warrant and will
      not have any liability or responsibility for any third-party materials or apps, or for any other materials,
      products, or services of third parties. We are not liable for any harm or damages related to the purchase or use
      of
      goods, services, resources, content, or any other transactions made in connection with any third-party apps.
      Please
      review carefully the third-party’s policies and practices and make sure you understand them before you engage in
      any
      transaction. Complaints, claims, concerns, or questions regarding third-party products should be directed to the
      third-party.

    </p>
    <b>USER COMMENTS, FEEDBACK AND OTHER SUBMISSIONS </b>
    <p>
      If, at our request, you send certain specific submissions (for example contest entries) or without a request from
      us
      you send creative ideas, suggestions, proposals, plans, or other materials, whether online, by email, by postal
      mail, or otherwise (collectively, ‘comments’), you agree that we may, at any time, without restriction, edit,
      copy,
      publish, distribute, translate and otherwise use in any medium any comments that you forward to us. We are and
      shall
      be under no obligation (1) to maintain any comments in confidence; (2) to pay compensation for any comments; or
      (3)
      to respond to any comments. We may, but have no obligation to, monitor, edit or remove content that we determine
      in
      our sole discretion are unlawful, offensive, threatening, libelous, defamatory, pornographic, obscene or otherwise
      objectionable or violates any party’s intellectual property or these Terms of Service. You agree that your
      comments
      will not violate any right of any third-party, including copyright, trademark, privacy, personality or other
      personal or proprietary right. You further agree that your comments will not contain libelous or otherwise
      unlawful,
      abusive or obscene material, or contain any computer virus or other malware that could in any way affect the
      operation of the Service or any related app. You may not use a false e-mail address, pretend to be someone other
      than yourself, or otherwise mislead us or third parties as to the origin of any comments. You are solely
      responsible
      for any comments you make and their accuracy. We take no responsibility and assume no liability for any comments
      posted by you or any third-party.

    </p>
    <b>PERSONAL INFORMATION</b>
    <p>
      Your submission of personal information through the app is governed by our Privacy Policy.



    </p>
    <b>ERRORS, INACCURACIES AND OMISSIONS</b>
    <p>
      Occasionally there may be information on our app or in the Service that contains typographical errors,
      inaccuracies
      or omissions that may relate to product/service descriptions, pricing, promotions, offers, product shipping
      charges,
      transit times and availability. We reserve the right to correct any errors, inaccuracies or omissions, and to
      change
      or update information or cancel orders if any information in the Service or on any related app is inaccurate at
      any
      time without prior notice (including after you have submitted your order). We undertake no obligation to update,
      amend or clarify information in the Service or on any related app, including without limitation, pricing
      information, except as required by law. No specified update or refresh date applied in the Service or on any
      related
      app should be taken to indicate that all information in the Service or on any related app has been modified or
      updated.

    </p>
    <b>PROHIBITED USES</b>
    <p>
      In addition to other prohibitions as set forth in the Terms of Service, you are prohibited from using the app or
      its
      content: (a) for any unlawful purpose; (b) to solicit others to perform or participate in any unlawful acts; (c)
      to
      violate any international, federal, provincial or state regulations, rules, laws, or local ordinances; (d) to
      infringe upon or violate our intellectual property rights or the intellectual property rights of others; (e) to
      harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate based on gender, sexual
      orientation, religion, ethnicity, race, age, national origin, or disability; (f) to submit false or misleading
      information; (g) to upload or transmit viruses or any other type of malicious code that will or may be used in any
      way that will affect the functionality or operation of the Service or of any related app, other apps, or the
      Internet; (h) to collect or track the personal information of others; (i) to spam, phish, pharm, pretext, spider,
      crawl, or scrape; (j) for any obscene or immoral purpose; or (k) to interfere with or circumvent the security
      features of the Service or any related app, other apps, or the Internet. We reserve the right to terminate your
      use
      of the Service or any related app for violating any of the prohibited uses.

    </p>
    <b>DISCLAIMER OF WARRANTIES; LIMITATION OF LIABILITY</b>
    <p>
      We do not guarantee, represent or warrant that your use of our service will be uninterrupted, timely, secure or
      error-free. We do not warrant that the results that may be obtained from the use of the service will be accurate
      or
      reliable. You agree that from time to time we may remove the service for indefinite periods of time or cancel the
      service at any time, without notice to you. You expressly agree that your use of, or inability to use, the service
      is at your sole risk. The service and all products and services delivered to you through the service are (except
      as
      expressly stated by us) provided ‘as is’ and ‘as available’ for your use, without any representation, warranties
      or
      conditions of any kind, either express or implied, including all implied warranties or conditions of
      merchantability, merchantable quality, fitness for a particular purpose, durability, title, and non-infringement.
      In
      no case shall vivo India Pvt. Ltd., Club Concierge Services (India) Pvt. Ltd, our directors, partners, officers,
      employees, affiliates, agents, contractors, interns, suppliers, service providers or licensors be liable for any
      injury, loss, claim, or any direct, indirect, incidental, punitive, special, or consequential damages of any kind,
      including, without limitation lost profits, lost revenue, lost savings, loss of data, replacement costs, or any
      similar damages, whether based in contract, tort (including negligence), strict liability or otherwise, arising
      from
      your use of any of the service or any products procured using the service, or for any other claim related in any
      way
      to your use of the service or any product, including, but not limited to, any errors or omissions in any content,
      or
      any loss or damage of any kind incurred as a result of the use of the service or any content (or product) posted,
      transmitted, or otherwise made available via the service, even if advised of their possibility. Because some
      states
      or jurisdictions do not allow the exclusion or the limitation of liability for consequential or incidental
      damages,
      in such states or jurisdictions, our liability shall be limited to the maximum extent permitted by law.
    </p>

    <b>INDEMNIFICATION</b>
    <p>
      You agree to indemnify, defend and hold harmless vivo Mobile India Pvt. Ltd., Club Concierge Services (India) Pvt.
      Ltd. and our parent, subsidiaries, affiliates, partners, officers, directors, agents, contractors, licensors,
      service providers, subcontractors, suppliers, interns and employees, harmless from any claim or demand, including
      reasonable attorneys’ fees, made by any third-party due to or arising out of your breach of these Terms of Service
      or the documents they incorporate by reference, or your violation of any law or the rights of a third-party.
    </p>

    <b>SEVERABILITY</b>
    <p>
      In the event that any provision of these Terms of Service is determined to be unlawful, void or unenforceable,
      such
      provision shall nonetheless be enforceable to the fullest extent permitted by applicable law, and the
      unenforceable
      portion shall be deemed to be severed from these Terms of Service, such determination shall not affect the
      validity
      and enforceability of any other remaining provisions.
    </p>

    <b>TERMINATION</b>
    <p>
      The obligations and liabilities of the parties incurred prior to the termination date shall survive the
      termination
      of this agreement for all purposes. These Terms of Service are effective unless and until terminated by either you
      or us. You may terminate these Terms of Service at any time by notifying us that you no longer wish to use our
      Services, or when you cease using our app. If in our sole judgment you fail, or we suspect that you have failed,
      to
      comply with any term or provision of these Terms of Service, we also may terminate this agreement at any time
      without notice and you will remain liable for all amounts due up to and including the date of termination; and/or
      accordingly may deny you access to our Services (or any part thereof).
    </p>
    <b>ENTIRE AGREEMENT</b>
    <p>
      The failure of us to exercise or enforce any right or provision of these Terms of Service shall not constitute a
      waiver of such right or provision. These Terms of Service and any policies or operating rules posted by us on this
      app or in respect to The Service constitutes the entire agreement and understanding between you and us and govern
      your use of the Service, superseding any prior or contemporaneous agreements, communications and proposals,
      whether
      oral or written, between you and us (including, but not limited to, any prior versions of the Terms of Service).
      Any
      ambiguities in the interpretation of these Terms of Service shall not be construed against the drafting party.

    </p>
    <b>GOVERNING LAW</b>
    <p>
      These Terms of Service and any separate agreements whereby we provide you Services shall be governed by and
      construed in accordance with the laws of Bengaluru, Karnataka, India.

    </p>
    <b>CHANGES TO TERMS OF SERVICE</b>
    <p>
      You can review the most current version of the Terms of Service at any time at this page. We reserve the right, at
      our sole discretion, to update, change or replace any part of these Terms of Service by posting updates and
      changes
      to our app. It is your responsibility to check our app periodically for changes. Your continued use of or access
      to
      our app or the Service following the posting of any changes to these Terms of Service constitutes acceptance of
      those changes.

    </p>
    <b>CONTACT INFORMATION</b>
    <p>
      Questions about the Terms of Service should be sent to us at xclub.support&#64;concierges.in.

    </p>
    <b>MEMBERSHIP ELIGIBILITY AND VALIDITY</b>
    <p>
      The XClub Membership offer is valid for all X80 series phones purchased up to 8th June 2022 (8th included), and
      the
      registration for the membership will be open till 20th June 2022. The XClub Membership is valid for a period of 12
      months from the date of Registration.

    </p>
    <b>ADDITIONAL TERMS & CONDITIONS</b>


    <b>PREMIUM CLUB ACCESS</b>
    <p>

      CLUB SOCIAL® (hereinafter referred to as CLUB SOCIAL) membership will provide access to members to select social
      and
      family clubs in the country and worldwide on the following terms & conditions: </p>
    <p> A. MEMBERSHIP </p>
    <p>1. CLUB SOCIAL® MEMBERSHIP: Membership allows free request for admission for the member (hereinafter referred to
      as
      member) to the member clubs which agreed to be part of the network. The membership is issued strictly by invite
      and
      for select individuals only. The list of member clubs may change at any time; the current list’s availability
      cannot
      be guaranteed, for example if the club is under renovation. If a club is hosting a private event, entrance may be
      denied. Admission to the club can be refused in particular, but not limited to, due to minimum age restrictions,
      improper dress or unacceptable conduct. CLUB SOCIAL cannot be held responsible if member clubs refuse entry. CLUB
      SOCIAL cannot be held responsible for disputes that may occur between the member and a third party. </p>
    <p>2. CLUB SOCIAL MEMBER MEMBERSHIP: The CLUB SOCIAL Membership is personal, nontransferable and may not be used by
      any person other than the registered member. The member must provide proof of identity on request.</p>
    <p>3. TRAVEL, HOTELS, FOOD & DRINK ETC.: CLUB SOCIAL is not responsible for any additional services except those set
      out in clause #1 above. Specifically, CLUB SOCIAL is not responsible for any costs for travel, accommodation, food
      and drink in connection with member events. If CLUB SOCIAL will be charged for any kind of costs caused by a
      member,
      in particular, but not limited to, for no shows, failure to meet the minimum consummation, CLUB SOCIAL shall be
      entitled to debit the respective amount to the /account.</p>
    <p>4. CONTRACT REVOCATION: CLUB SOCIAL reserves the right to withdraw the facility to any member at its own
      discretion.</p>
    <p>5. CONTRACT DURATION: The membership is valid up to and including the expiry date as per the membership category.
      Cancellation, if any, has to be received by registered letter or through email to support&#64;theclubsocial.com. Both
      parties must confirm the cancellation in writing, either via e mail or postal service. CLUB SOCIAL reserves the
      right to review and change the membership terms at any time.</p>
    <p>6. PERSONAL DATA: The member must promptly communicate every change of name, address, mobile telephone number or
      email details to CLUB SOCIAL. The club member can choose to post his personal profile online. Through this
      membership, the member explicitly agrees that CLUB SOCIAL may share his/her personal data with selected partners
      for
      advertising, promotion and marketing purposes.</p>
    <p>7. EXCLUSION: CLUB SOCIAL reserves the right to deny member applications without giving reasons. Possible reasons
      for denial are in particular, but not limited to, unacceptable behavior in our member clubs or misuse of the
      personal, nontransferable Membership. If the membership is abused in any way, CLUB SOCIAL reserves the right to
      terminate the membership with immediate eﬀect. In the event of abuse, the CLUB SOCIAL Membership may be revoked
      and
      will be returned to the member only after an acceptable explanation has been provided. </p>
    <p>8. MEMBER CLUB VISITS:</p>

    <p>8.1 All Member club visit requests shall be made through its app booking request tool.</p>
    <p>8.2 Member visit requests for participating clubs shall be made at least 2 - 14 days in advance and are based on
      space availability as determined by the host club.</p>
    <p>8.3 Members of CLUB SOCIAL may not contact the host club directly to request for access. Doing so will result in
      the termination of membership privileges.</p>
    <p>8.4 All Members will be charged the standardized fee of the host club, and any other normal customary charges
      paid
      by the members of the host club. Individual members shall be aware that the facilities and services of other
      Member
      Clubs may be diﬀerent in each case.</p>
    <p>8.5 Individual members using the provisions of Club Social purposes upon checking in at the host club.</p>
    <p>8.6 Each host club, at its discretion, will determine whether guests may accompany CLUB SOCIAL members and the
      associated guest fees.</p>
    <p>8.7 At some clubs, individual may not be able to use another Member Club, if they reside in the same city.
      Individuals must observe all guest policies when they visit other Member Clubs.</p>
    <p>8.8 The staﬀ of the host club shall have complete control of assigning facility usage based upon request of
      customer service centre.</p>
    <p>9. CONTRACT ADJUSTMENTS: CLUB SOCIAL reserves the right to alter these Terms and Conditions, in whole or
      partially
      at any time without prior notice. All such changes will be notified to the members by email.</p>
    <p>10. APPLICABLE LAW AND PLACE OF JURISDICTION: The contractual relationship between CLUB SOCIAL and the member
      shall
      in all respects be governed by the laws of courts of Bangalore, India, including all matters of construction and
      validity. </p>


    <b>B. TERMINATION</b>
    <p>
      1. In the event of misuse of the membership, we, Club Social® reserve the right to exclude the member(s) in
      question
      from the programme. Such misuse may include, but is not limited to, behavior which is troublesome or shows a lack
      of
      respect towards staﬀ, partners or clubs, criminal actions or actions that are generally regarded to be immoral,
      unethical or contrary to these membership terms and conditions.</p>
    <p>2. We, Club Social® reserve the right without prior notification to individual members, to change the terms and
      conditions as deemed fit for the membership programme. Any such changes will be published on the web- app and will
      be in eﬀect 14 days after these changes are announced, unless otherwise stipulated. Members are responsible for
      keeping themselves informed about any changes to the membership terms and conditions.</p>

    <b>C. PAYMENT TERMS</b>
    <p>
      1. After a booking is made, it may take up to 3-7 working days (14 days for international Club Bookings) for us,
      Club Social® to confirm the same to you, so members are encouraged to make all bookings in advance. We will
      endeavor
      to do so at the earliest.
    </p>
    <b>D. PRIVACY</b>
    <p>1. In respect of any and all personal data you provide to us as part of your membership, we will be the data
      controller. For the purposes of data protection, we agree to comply with the principles of data protection as per
      law and our obligations thereunder.</p>
    <p>2. You agree that we may share:</p>
    <p>2.1 Your personal data with partner clubs for the purpose of facilitating your bookings.</p>
    <p>2.2 Usage data available with us for the sole purpose of improving our service to you.</p>
    <p>
      3. You further agree that we may use the contact details provided by you to communicate with you in relation to
      your
      membership.
    </p>

    <b>E. LIMITED LIABILITY & INDEMNITY </b>
    <p>1. We do not operate the facilities at the Partner clubs and will not be liable for:</p>
    <p>1.1 The security, safety or appropriateness of the facilities. The accuracy of any content or material which is
      listed on the (URLs, location or contact details), or any reliance placed by you on such content or material.</p>
    <p>1.2 Any direct, indirect or consequential loss, injury, damage or inconvenience you may suﬀer as a result of:</p>
    <p>1.2.1 The act or omission of any partner club or any failure by the partner club to perform to comply with the
      terms of any booking.</p>
    <p>1.2.2 Your use of the facilities (or any other activity you undertake) at the partner clubs.</p>
    <p>1.2.3 Your inability or incapacity (for whatever reason, including without limitation, ill or unfit health) to
      use
      the facilities.</p>
    <p>2. You agree that you are fully aware of any and all risks and hazards associated with participation and use of
      the
      facilities. To the fullest extent permitted by law, you hereby release, hold harmless, and forever discharge,
      sanctify Partners, and each of our employees and agents, from any and all liability in relation to bookings, use
      of
      facilities and travel to and from partner clubs to avail of facilities.</p>
    <p>3. We will not be liable for any direct, indirect or consequential loss or damage incurred by you in connection
      with the app/app or the making of bookings by you on the app/app, including, without limitation: loss of income or
      revenue; loss of business; loss of profits or contracts; loss of anticipated savings; loss of data; loss of
      goodwill; wasted management or office time; and for any other loss or damage of any kind, however arising and
      whether caused by tort (including negligence), breach of contract or otherwise, even if foreseeable.</p>
    <p>4. Nothing in these terms shall exclude our liability for death or personal injury caused by our negligence or
      fraudulent misrepresentation.</p>
    <p>5. Whilst we take every care to maintain the continuity of the app/app, the internet is not always a stable
      medium,
      and errors, omissions, interruptions of service and delays may occur at any time. We do not accept any liability
      for
      any app downtime, or your inability to make bookings as a result, and you agree that we shall have no obligation
      or
      responsibility to operate the App or any part of it.</p>
    <p>
      6. We will not be in breach of these terms, or otherwise liable for any failure or delay in performance, arising
      from any circumstances beyond our reasonable control including, without limitation, strikes, lockouts and other
      industrial disputes, breakdown of systems or network access, ﬂood, fire, explosion or accident.
    </p>
    <p>7. Other terms and conditions may apply.</p>



    <b>XCLUSIVE EXPERIENCES</b>

    <p>1. The acceptance of a service request is subject to the payment of an advance amount as specified by CC. The
      User
      is entitled & willing to receive an acknowledgment (form / email) for any monies or other valuables handed over to
      an authorised staff of CC.</p>
    <p>2. The acceptance of a service request does not guarantee fulfilment of the request.</p>
    <p>3. CC will not be held responsible for any acts, omissions or errors or consequences thereof, of such Third Party
      Service Providers.</p>
    <p>4. CC, its staff or its affiliates will not be held responsible, liable for an inconvenience, loss or damage
      (direct or indirect) caused to anyone by its acts, omissions or errors, in its attempt to fulfil any of the
      services.</p>
    <p>5. CC, at its sole discretion, may accept requests / instructions from the User over the telephone and any other
      method that does not require the customer’s instructions in writing. CC does not guarantee to conduct security or
      identification checks on such instructions. Consequently, the customer accepts the risk that CC may accept, and
      process instructions purported to be issued by the User. CC will not be held liable for any loss or other
      consequences of acceptance of such instructions.</p>
    <p>6. In addition, to the value of the service request, CC may levy handling, vendor and other charges to every
      service request, which may vary from time to time, without prior notice. The User accepts the responsibility to
      enquire / be advised of these charges. The User accepts to pay the full amount (inclusive of all charges), on
      demand
      to CC. CC reserves the right to prevent the User’s use of the services and also proceed in any manner available to
      CC to recover the outstanding payments from the User.</p>
    <p>7. The User accepts the responsibility to exercise due diligence in the acceptance of the services and to take
      all
      necessary precaution to protect life and property wherever applicable, during the fulfilment of the service
      request.
      CC will not be responsible for any loss or injury caused by virtue of the customer utilising the services of CC,
      its
      staff or affiliates.</p>

    <b>Service Changes and Cancellations </b>
    <p>
      CC will be unable to cancel or change request already in process, en-route, delivered or non-cancellable. If you
      are
      calling about an Experience / Event that is scheduled to be processed and delivered within the next 72 hours,
      request for call back through the XClub app. For other cancellations / changes, email vivosupport&#64;concierges.in.
      Your cancellation / change request will be reviewed and confirmed on the basis of the applicable cancellation /
      change request policy.
      All cancellations will be subject to the respective cancellation policy of the experience / event requested for by
      the User.
      If in case any issue with a request
      At CC, we make every effort to ensure that you receive excellent service. If, at any time, you experience problems
      with a request, please let us know / please write us on vivosupport&#64;concierges.in or use call back option in the
      App.
      Please note; we are unable to entertain any complaint for perishable products like fresh flowers, cake, etc. after
      24 hours from the time of delivery.
    </p>
    <b>Shipping & Delivery Policy </b>
    <p>At CC every product and service is personally handled by an industry professional, and we make every effort to
      process and fulfil your request as quickly as possible.
      Lead times for booking and delivery of tickets will be on a case to case basis, dependent on the respective
      Experience / Event booking.
      Regretfully, we are unable to guarantee completion of request to rural route addresses. To request a specific
      delivery time or specific information, please provide your special Instructions in additional information field at
      the time of placing the request. We will do our best to accommodate your preferences.
      Before major holidays, we recommend that you place your request at least 15 working days in advance or as
      specified
      in the description of the respective Experience / Event, whichever is earlier. You acknowledge that requested
      delivery dates are non-binding estimates only and that you have no claim against us for any delays or early
      deliveries. We reserve the right to make deliveries in instalments, which shall not relieve you from your
      obligation
      to accept and pay for remaining deliveries. Our service providers do not telephone/reach out to you prior to
      delivering packages, and we cannot guarantee the time of delivery. All tickets / products / services are deemed
      accepted upon our delivery of the same to you or your designated recipient’s address.</p>
    CC is not responsible for:
    <p>1. Any services delivered to incorrect addresses supplied by the User.</p>
    <p>2. Unsuccessful deliveries arising from the recipient not being present at time of delivery at the address
      supplied
      by the sender.</p>
    <p>3. Decreased product / service quality due to an incorrect delivery address supplied by the User, or a re-route
      requested by the sender.</p>
    <p>4. Ticket / Product quality problems caused by improper handling by the recipient.</p>

    <b>If Customer Not Home Policy</b>
    <p>If you have specific instructions for the delivery of your tickets / product / service, please note them in the
      additional information field during placing request. In all other cases, if the recipient is not at home when CC
      attempts a delivery, they will either:</p>
    <p>1. Call the recipient to schedule an appropriate delivery time.</p>
    <p>2. Leave a note on the recipient’s door asking them to contact CC to schedule a delivery time.</p>
    <p>3. Leave your delivery with a neighbour and place a message on the recipient’s door with this information.</p>

    <b>Payment Options </b>
    <p>CC uses the Industry’s leading security technology to ensure that your request will be safe and secure. For your
      convenience, CC accepts payments made through Visa, MasterCard, UPI, NEFT.</p>
    <b>Support Order-Related E-mails</b>
    <p>Shortly after you place a request, you will receive a request confirmation e-mail. Please put this in a safe
      place,
      as it will include all the details of your order, including an order number, in the event you need to contact us.
      To
      show our appreciation, you will receive a confirmation e-mail from us when your request is completed.
    </p>
    <b>Redirection Policy</b>
    <p>
      The delivery will NOT be redirected / redelivered to any other address in any circumstance.</p>
    <b>What you should know about Courier Deliveries</b>
    <p>Domestic: All courier orders are carefully packed and dispatched from our partners. Soon after the order has been
      dispatched, you will receive a tracking number that will help you trace your product/service. Any other levies,
      taxes or duties enforced by the government would be charged extra, if and as applicable at the delivery location.
      International: All parcels are shipped from our partners. Once the parcels are shipped, you will receive a
      tracking
      code to help trace the order. Any other levies, taxes or duties enforced by the government would be charged extra,
      if and as applicable at the delivery location.
      In the event the address provided is wrong, we regret to inform we will be unable to deliver your tickets /
      product
      / service. Courier partners sometimes have some delays due to holidays and strikes. We try our best to use the
      best
      services, but some delays are unavoidable.
    </p>
    <b>Pricing Policy</b>
    <p>
      All prices listed on the app are subject to change. In the event a product / service (including, but not limited
      to,
      tickets to events / experiences) is listed at an incorrect price or with incorrect information due to
      typographical
      error or error in pricing or product information received from our suppliers, we shall have the right, prior to
      the
      acceptance of your order, pursuant to our Order Acceptance Policy described below, to refuse or cancel any such
      orders whether or not the order has been confirmed and your credit card charged. If your credit card has already
      been charged for the purchase and your order is cancelled, we shall immediately issue a credit to your credit card
      account in the amount of the charge.
      Please note that the colours of items and products may depend on your monitor and may not be correctly displayed.
      The availability of products and other items on the app may change at any time, without notice.
    </p>
    <b>Order Acceptance Policy</b>
    <p>
      Your receipt of an electronic or other form of request confirmation does not signify our acceptance of your
      request,
      nor does it constitute confirmation of our offer to sell. We reserve the right at any time after receipt of your
      request to accept or decline your request for any reason. We reserve the right at any time after receipt of your
      request, without prior notice to you, to supply less than the quantity you ordered of any item. We may require
      additional verifications or information before accepting any request. Notwithstanding the foregoing, you agree
      that,
      if we cancel all or a portion of your request or if we provide you less than the quantity you ordered, your sole
      and
      exclusive remedy is either (a) we will issue a credit to your credit card account in the amount charged for the
      cancelled portion or the quantity not provided (if your credit card has already been charged for the order) or (b)
      we will not charge your credit card for the cancelled portion of the order or the quantity not provided.

    </p>
    <b>Payment Terms</b>
    <p>
      For each product or service you request on the app, you agree to pay the price applicable for the product or
      service
      (including any sales taxes, surcharges and any delivery fees for the delivery service you select) as of the time
      you
      submitted the request.</p>
    <b>Holiday Policy</b>
    <b>Local Public Holidays</b>
    <p>Please be aware that CC cannot guarantee delivery on Public Holidays in the state or country of the delivery
      location. Please check the Public Holidays listing by the government of the recipient’s country / city before
      placing your request.
      Any complaints must immediately be addressed to CC to the attention of the X Concierge® team or via email to
      vivosupport&#64;concierges.in

    </p>
    <h3>AIRPORT PRIVILEGES</h3>

    <b>Airport Lounge </b>

    <p>1. General</p>
    <p>
      1.1 "Lounge Facilities" means the provision of a waiting area in the Airside/Landside area of the Airport with
      seating and refreshment facilities including (facilities in different locations may vary):</p>

    <p>(a) Hot showers facilities including amenities;</p>
    <p>(b) Food and beverages;</p>
    <p>(c) Use of computers to access the Internet;</p>
    <p>(d) DVD / VCD movie viewing (at selected locations only);</p>
    <p>(e) Selection of local / International magazines and newspapers;</p>
    <p>(f) Power and Internet connection for travelers with laptop computers;</p>
    <p>(g) Mobile/laptop battery recharging facilities;</p>
    <p>(h) Telephone for local calls</p>
    <p>(i) Flight Information</p>

    <p>1.2 "Airport" means the airport from which the Customer is traveling.</p>

    <p>1.3 "Charges" means the charges paid by the Customer to vivo XClub App Airport Lounge services in respect of
      Lounge
      Facilities offered on the App</p>

    <p>2. Formation of Contract</p>

    <p>2.1 The Lounge Facilities are provided by vivo XClub App Airport Lounge services subject to these terms and
      conditions, which the Customer shall indicate and qualify acceptance of by booking the Lounge Facilities and
      paying
      the Charges.</p>

    <p>3. Lounge Facilities</p>

    <p>3.1 All specifications, descriptions, drawings, photographs, or illustrations of the Lounge Facilities and any
      advertising matter and sample books are only intended to serve as a guide and not to be relied upon by the
      Customer
      or treated as binding or as forming part of these conditions or any contract with the Customer.</p>

    <p>3.2 vivo XClub App Airport Lounge services shall use its reasonable endeavors to provide the Lounge Facilities
      during the hours advertised for each Airport but reserves the right to vary the hours of operation or close the
      executive lounge due to refurbishment, relocation, or otherwise in which case an alternative executive lounge
      facility will be provided, or a refund of the charges will be made at the discretion of vivo XClub App Airport
      Lounge services. In the unlikely event that entry to the Lounge Facilities is refused due to capacity constraints,
      the Customer will receive a complimentary voucher for their next visit to the lounge.</p>

    <p>3.3 Vivo XClub App Airport Lounge services shall use its reasonable endeavors to ensure a suitable environment is
      maintained in the Lounge Facilities including but not limited to keeping the area where Lounge Facilities are
      provided clean and tidy, ensuring staff is on hand to respond to any queries and ensuring the removal from the
      lounge area of any persons whose behavior is unsuitable.</p>

    <p>3.4 vivo XClub App Airport Lounge services shall have the right to refuse a Customer entry to the Lounge
      Facilities
      for any Statutory, or regulatory of Airport policy reasons including but not limited to health and safety policies
      or fire regulations.</p>

    <p>3.5 To maintain Customer expectations, children are not permitted to use the Lounge Facilities in certain
      Lounges.
      Please check the individual Lounge information on this app for details. If children are permitted access to the
      Lounge, they should be accompanied in all Lounges Facilities by a Customer over the age of eighteen years at all
      times.
    </p>
    <p>4. Charges</p>

    <p>4.1 Charges payable for the Lounge Facilities shall be as stated in the vivo XClub App Airport Lounge services'
      menu (current at the date of booking).
    </p>
    <p>5. Terms of Payment</p>

    <p>5.1 Customers shall make payment for the Lounge Facilities when booking by entering the details on the vivo XClub
      App.</p>

    <p>5.2 Unless otherwise agreed in writing, the Customer shall not be entitled to get any discount.</p>
    <p>
      5.3 A transaction fee (“Fee”) could be imposed on your total transaction amount by the card-issuing bank. You
      shall
      be solely liable to pay the Fee. We are not responsible for any liabilities arising from non-payment of the Fee.
    </p>

    <p>6. Customer's obligations</p>

    <p>6.1 The Customer shall ensure that he is at all times appropriately dressed and shall behave appropriately. The
      lounge provider with whom vivo XClub App Airport Lounge services has entered into an arrangement for the provision
      of Lounge Facilities reserve the right at their sole and absolute discretion to refuse entry or to remove any
      customer whose behavior or mode of dress is considered by Lounge Provider to be unsuitable or is likely to offend
      other customers.
    </p>
    <p>6.2 Customers must not remove food and/or drinks from the Executive Lounge Facilities and will be asked to
      refrain
      from consuming food and/or drinks in the Lounge Facilities other than food and/or drinks provided in the Lounge
      Facilities.
    </p>
    <p>6.3 The Customer agrees to adhere to any no-smoking policies in operation in any of the Lounge Facilities.</p>

    <p>6.4 Complimentary bookings, including redemption bookings are non-cancellable and non-modifiable.</p>
    <p>6.5 For lounge facilities reservation and cancellation, the customer must reach out to customer support at
      vivosupport&#64;concierges.in, the customer agrees to adhere to the cancellation policy mentioned on the booking
      confirmation. </p>

    <p>7. Limitation on Liability</p>

    <p>7.1. vivo XClub App shall under no circumstances be liable for any indirect, special, or consequential loss,
      including but not limited to loss of profit, loss of contract, loss of revenue, or loss of business, however
      arising
      whether in contract, tort (including negligence) or statutory duty or otherwise.</p>
    <p>7.3 The customer is aware vivo XClub App is only an aggregator and is offering a platform to reserve Third Party
      services. The customer agrees to adhere to the individual lounge policy</p>

    <p>7.2 vivo XClub App does not exclude loss arising from death or personal injury caused by negligence.</p>
    <p>
      7.3 Subject to clause 7.2 above, the aggregate liability of vivo XClub App A, (whether in contract, tort
      (including
      negligence) or breach of statutory duty, or otherwise) to no circumstances shall exceed the Charges paid by the
      Customer for the Lounge Facilities.</p>

    <p>7.4 vivo XClub App Airport Lounge services shall under no circumstances be liable for any Customer failing to
      board
      his flight and neither vivo XClub App Airport Lounge services nor any third-party lounge provider with whom vivo
      XClub App Airport Lounge services has entered into an arrangement for the provision of Lounge Facilities has any
      obligation to make flight announcements.</p>

    <p>7.5 vivo XClub App Airport Lounge services shall under no circumstances be liable or responsible for the personal
      belongings of any Customer, and a Customer shall take personal belongings into the Lounge Facilities area solely
      at
      his own risk.</p>
    <p>
      7.6 All information, recommendations, and advice given by or on behalf of vivo XClub App Airport Lounge services
      to
      the Customer regarding Airport services or flight details are given without liability on the part of vivo XClub
      App
      Airport Lounge services.</p>

    <p>7.7 The Customer shall fully indemnify and compensate vivo XClub App Airport Lounge services, its employees,
      sub-contractors, and agents in respect of all actions, suits, claims, demands, costs, charges, or expenses arising
      (whether asserted by the Customer or third party) out of or in connection with the provision of the Lounge
      Facilities which:</p>

    <p>(a) are more than vivo XClub App Airport Lounge services' liability set out in clause 7.3 above; and</p>
    <p>(b) are caused directly or indirectly through the act or omission, wilful misconduct or negligence of the
      Customer.
    </p>

    <p>8. Force Majeure</p>

    <p>8.1 vivo XClub App Airport Lounge services shall not be liable to the Customer for any loss or damage caused to
      or
      suffered by the Customer as a direct or indirect result of the provision of the Lounge Facilities by or on behalf
      of
      vivo XClub App Airport Lounge services being prevented, restricted, hindered or delayed because of any
      circumstances
      outside the control of vivo XClub App Airport Lounge services.</p>


    <b>Airport Cabs</b>
    <h3>ELIGIBILITY</h3>
    <p>
      You will be “Eligible” to use the Services only when you fulfill all of the following conditions: (i) You have
      attained at least 18 (eighteen) years of age.

    </p>
    <b>SERVICES</b>
    <p>
      The Services allow you to send a request through vivo XClub platform to a Driver on the third-party marketplace
      service providers. The Driver has sole and complete discretion to accept or reject each request for Service. If
      the
      driver accepts a request, vivo XClub App notifies you and provides information regarding the Driver - including
      the
      Driver Name, Vehicle Number, telephone contact details of the Driver, and such other details as vivo XClub may
      determine.
      vivo XClub App shall procure reasonable efforts to bring you into contact with a Driver, subject to the
      availability
      of a Driver in or around your location at the moment of your request for such services.
      vivo XClub bears no responsibility and liability for delays and losses suffered by you or caused to you as a
      consequence of the breakdown of the Vehicle or the Substitute Vehicle.

    </p>
    <b>CONFIRMATION OF BOOKING</b>
    <p>
      vivo XClub shall, upon receiving the booking request from you in the manner set out above, proceed to confirm or
      decline the booking based on the availability of Vehicles at the pickup time, which shall be informed to you vide
      an
      SMS or email/notification. In the event the booking is confirmed, you shall check the booking details including
      but
      not limited to pick up time and pick up place, and if there is incorrect detail, the same needs to be informed to
      us
      immediately by calling our call center.
      You shall bear the consequences and damages for any delay that may be caused to you due to your failure to check
      the
      confirmation SMS or email/notification or failure to inform X Concierge® of the incorrect details immediately.

    </p>
    <b>PAYMENT</b>
    <p>
      Third-party cab service providers shall charge amounts as may be informed to you by the third-party service
      providers if you opt for such services, from time to time. You shall be required to pay such Additional Fee, which
      will form part of the receipt of the Total Ride Fee.
      In addition to the Total Ride Fee, you may be required to pay such other charges incurred by you during the Ride
      in
      cash i.e. Toll Charges, Municipal Taxes which are not included in the receipt of the Total Ride Fee.
      The Total Ride Fee will be collected by the Driver or vivo XClub from you at the end of the Ride or as per the
      payment option selected by you. All applicable taxes in respect of the Fare, Convenience Fee, Additional Fee,
      Cancellation Fee shall be borne and payable by You to the Third-party service providers or vivo XClub, as the case
      may be.

    </p>
    <b>CANCELLATION POLICY</b>
    <p>
      You agree and acknowledge that you may cancel your request for a Vehicle on the app at any point in time subject
      to
      a Cancellation Fee. You shall be notified of the applicable Cancellation Fee in advance whenever You attempt to
      cancel a booking/service request. The notification shall be on the web application and/or the App.


    </p>
    <b>CUSTOMER RELATIONSHIP MANAGEMENT</b>
    <p>
      All issues, opinions, suggestions, questions, and feedback while availing of our Services shall be communicated to
      us through the email address vivosupport&#64;concierges.in. In case of a Ride booked on our web application, you shall
      be required to rate the Ride after its completion. You agree to be fair, accurate, and non-disparaging while
      leaving
      comments, feedback, testimonials, or reviews on or about the Rides or Services.
      Reporting of any issue needs to be within 7 (seven) days of the issue, failing which, such issue will not be
      addressed.
      Any issue reported on channels other than the above may be addressed by vivo XClub only on a best-effort basis.
      vivo
      XClub takes no liability for the inability to get back on other channels.

    </p>
    <b>INDEMNIFICATION</b>
    <p>
      By accepting these User Terms and using the Service, You agree that You shall defend, indemnify and hold vivo
      XClub,
      its affiliates, their licensors, and each of its officers, directors, other users, employees, attorneys, and
      agents
      harmless from and against any claims, costs, damages, losses, liabilities, and expenses (including attorneys' fees
      and costs) arising out of or in connection with: (a) Your violation or breach of any term of these User Terms or
      any
      Applicable Law or regulation, whether or not referenced herein; (b) Your violation of any rights of any third
      party,
      including the Third-party service providers \or (c) Your use or misuse of the web application or Service.

    </p>
    <b>LIABILITY</b>
    <p>
      vivo XClub shall not be liable for flights as the Service is dependent on many factors not in vivo XClub’s
      control.
      You must book Your Ride after taking into account the check-in time, traffic and weather conditions, political
      rallies, natural calamities, traffic barricades, car breakdowns, and other unexpected delays.
      In the event, there is a delay by the Vehicle in reaching the pickup location beyond 30 (thirty) minutes of the
      pickup time, vivo XClub shall only endeavor to get You in touch with the Driver assigned for Your Ride.
      You shall take full responsibility for Your items and luggage. In case of lost items inside the vehicle during the
      journey, vivo XClub will try to locate the items on a “best-effort” basis but is not responsible for the same in
      case of loss or damage to the same.
      vivo XClub will not be responsible for the appropriateness of mobile or email or any other communication medium.
      You
      shall be responsible for immediately reporting the errors, if any, that occurred in the information sent to You
      regarding a booking confirmation.
      In no event shall vivo XClub be liable for any direct, indirect, punitive, incidental, special, or consequential
      damages or any damages whatsoever, whether based on contract, tort, negligence, strict liability, or otherwise,
      even
      if vivo XClub has been advised of the possibility thereof.in addition, and without limiting the foregoing, to the
      fullest extent permitted by applicable law, in no event will vivo XClubs' aggregate liability arising out of or in
      connection with these user terms or the services rendered hereunder, whether in contract, tort (including
      negligence, product liability, or other theory), warranty, or otherwise, exceed the amount of total transaction
      value for the ride.
      vivo XClub service is brought to you by vivo XClub App marketplace partners. All liabilities arising out of
      customer
      availing of vivo XClub service or related services offered on the platform will be the sole responsibility of the
      respective service provider chosen by the customer.

    </p>
    <b>DISCLAIMER</b>
    <p>
      You agree that vivo XClub is merely an electronic marketplace platform to facilitate the aggregation of Vehicles
      via
      the third-party service providers and does not in any manner provide transportation services. vivo XClub does not
      endorse, advertise, advise or recommend you avail the Services of any Driver. vivo XClub also does not guarantee
      or
      assure respect of the behavior, actions, or data of the users posted on the App.</p>

    <p>
      vivo XClub and their representatives, officers, employees, agents, and contractors shall not be liable for any
      loss,
      damage, claim, expense, cost (including legal costs), or liability arising directly or indirectly from Your use or
      non-use of the Service or the App, or Your reliance upon the Service or the information contained upon the App
      (whether arising from vivo XClub or any other person's negligence or otherwise).
    </p>



    <h3>Airport Meet & Greet</h3>

    <p>● A booking becomes legally binding when the Vivo XClub App partner sends the confirmation voucher via email.</p>
    <p>● Bookings are required to be made 48 working hours in advance of your departure / arrival time</p>
    <p>● Charges for our services are payable in full when a booking is made. Cancellations and amendments are subject
      to
      our Amendments, Refund & Cancellation policy.</p>
    <p>● vivo XClub App Services are provided by third-party organizations (“Suppliers”). There may be specific rules
      and
      policies in place at certain airports. By using vivo XClub App Services, you agree to be bound by these specific
      rules and policies.</p>
    <p>● We will use reasonable actions to ensure that the services are provided as advertised, but We do not warrant or
      guarantee this, and We are not liable for any loss to you or any co-traveler, arising directly or indirectly from
      the provision or non-provision (whether in whole or in part) of the advertised service.</p>
    <p>● Any special additional wishes that are not part of the booked service package, will be separately charged.</p>
    <p>● Unless otherwise confirmed by Us in the Terms of Service, vivo XClub App Services do not include entry to any
      airport lounge. Airport Lounge access may be available at selected lounges and select airports subject to an
      additional charge.</p>
    <p>● The booking made on vivo XClub App is not transferable.</p>
    <p>● All services provided by vivo XClub App are subject to availability.</p>

    <b>Force Majeure Circumstances</b>
    <p>● Airports worldwide can witness unforeseen security restrictions being imposed by the Government, Airport
      Authorities, or Security agencies, due to certain security situations at the Airport or even for undisclosed
      reasons. In such cases, all the Airport Assistance services can be suspended without prior notice. This can lead
      to
      the inability to provide the booked services. But in such scenarios, you will receive a full refund of the Booking
      Fee.</p>
    <p>● In certain cases, delays and cancellations may result from factors beyond our or our suppliers’ control such as
      the weather, accidents, governmental restrictions, and other events of force majeure. In such cases, our liability
      is limited to the re-performance of the canceled vivo XClub App service. In exceptional circumstances, a refund or
      partial refund may be given at our discretion and/or the discretion of the supplier of the vivo XClub App services
      concerned but it is not guaranteed.</p>
    <p>● Clients are required to realize that the immigration and customs facilities are independent units.
      Consequently,
      each unit imposes its regulations that must be followed and fulfilled. While completing the regular procedures of
      these units, clients will have to carry and transfer their documents and personal belongings for security checks.
      The passenger will be escorted by a greeter through this process. However, the greeter is not allowed to
      intervene.
    </p>
    <p>● Kindly note that the immigration, airlines, and airport meet and greet service provider are three different
      entities, as a result, any potential delay, border rules changes, cancellation, or airlines rejection to PAX
      entrance into a specific country and/or boarding the plane will be accordingly applied to the airport meet and
      greet
      terms and conditions. The airport meet and greet team will not be held responsible for the decisions of the
      customs,
      airlines, or immigration.</p>
    <p>● Please be noted that the availability of service and airport regulations are flexible and may be adjusted
      anytime
      without any prior notice due to the current situation.</p>


    <b>The onus of the User/ Customer</b>
    <p>● You acknowledge and agree to read and abide by the Terms of Service, as these define what services are included
      within the vivo XClub App Services for your specific journey.</p>
    <p>● Bookings containing incorrect Customer details, flight details, terminal details, and/or product selection may
      be
      considered void by us.</p>
    <p>● You acknowledge and accept that it is your sole responsibility to ensure that the information supplied in your
      Reservation Request is correct. We will not be responsible in any circumstances for incorrect, incomplete, or
      similar information supplied at the time of booking including but not limited to dates, flight numbers, arrival or
      departure times.</p>
    <p>● Further, you acknowledge and accept that it is your sole responsibility to ensure that the contact details you
      provide when making your Reservation Request (including but not limited to the email address and contact telephone
      number) are complete, valid, and correct. We will not be responsible should an incorrect, incomplete, or invalid
      number or contact details be given.</p>
    <p>● Your booking will cover you and any co-travelers booked and confirmed by us on your behalf, for the services to
      be provided by Supplier’s representative (“Representative”) at the airport for a certain maximum number of hours,
      which will be detailed in the Terms of Service.</p>
    <p>● vivo XClub App Services for children and the fees vary across the Suppliers, Customers are advised to check
      with
      Us </p>
    <p>● If you require the services of the Representative for additional hours, then this must be arranged directly
      with
      the Representative on the day of the service and will incur an additional payment.</p>
    <p>● The Representatives are not insured, contracted, or similar, to carry or store your baggage. Unless
      specifically
      stated as being included in the Terms of Service any porter charges are not included in the vivo XClub App
      Services
      and you will be solely liable for such charges.</p>
    <p>● vivo XClub App Services are only available to eligible Customers. Prices do not include any additional
      travelers
      not named at the time of booking. Such persons are subject to an additional charge if they accompany the
      Customer(s).</p>
    <p>● For departure services, it is your responsibility to book a time for your arrival at the airport that allows
      sufficient time for the service to take place and for all procedures (check-in, security clearance, etc.) to be
      completed in good time for you to catch your flight.</p>

    <b>Payment Terms</b>
    <p>● The customers will make payment on vivo XClub App for their desired services of Airport Meet & Greet</p>
    <p>● Payment terms for any services excluded from the vivo XClub App Services will be payable directly to the
      Supplier
      and the payment terms of the Supplier will be applied.</p>
    <p>● We reserve the right not to fulfill your booking if your payment method is declined for any reason or if the
      payment method has been used fraudulently or without the cardholder’s permission or if you are under the age of
      18.
    </p>


    <b>vivo XClub App Terms & Conditions Update</b>
    <p>● Clients are required to realize that the immigration and customs facilities are independent units.
      Consequently,
      each unit imposes its regulations that must be followed and fulfilled. While completing the regular procedures of
      these units, clients will have to carry and transfer their documents and personal belongings for security checks.
      The passenger will be escorted by a greeter through this process. However, the greeter is not allowed to
      intervene.
    </p>
    <p>
      ● Kindly note that the immigration, airlines, and airport meet and greet service provider are three different
      entities, as a result, any potential delay, border rules changes, cancellation, or airlines rejection to PAX
      entrance into a specific country and/or boarding the plane will be accordingly applied to the meet and greet terms
      and conditions. The airport meet and greet team will not be held responsible for the decisions of the customs,
      airlines, or immigration.</p>
    <p>● Please be noted that the availability of service and airport regulations are flexible and may be adjusted
      anytime
      without any prior notice due to the current situation.</p>
    <p>Identification</p>
    <p>● You are required to provide full and accurate personal information and contact details when making a
      Reservation
      Request and you must notify us of any change in the information you have provided (for example if you change your
      mobile telephone number).</p>
    <p>
      ● If you provide incorrect information this may invalidate your Booking and entitlement to any refund.
    </p>
    <p>● You acknowledge that our use of confirmed vivo XClub App Airport Meet & Greet Services is conditional upon the
      presentation of the correct Final Booking Confirmation to the Representative.</p>
    <p>● The VIP Greeters will be holding a NAME SIGN with the passenger’s name. The client must then identify himself
      or
      herself to the VIP Greeter within an appropriate amount of time (until deplaning has been completed), this will be
      considered as NO SHOW and full charges will be applied.</p>

    <b>Indemnification</b>
    <p>
      You agree to indemnify and defend vivo XClub App and its suppliers from and against any claims, causes of action,
      demands, recoveries, losses, damages, fines, penalties, or other costs or expenses of any kind or nature including
      but not limited to reasonable legal and accounting fees, brought by: </p>
    <p>• you or on your behalf in excess of the liability described above; or</p>
    <p>• by third parties as a result of</p>
    <p>• your breach of this agreement or the documents referenced herein;</p>
    <p>o your violation of any law or the rights of a third party; or</p>
    <p>o your use of this App</p>

    <b>SIGNATURE STAYS</b>

    <p>1. An Electronic Confirmation Voucher (e-CV) would be sent to confirm bookings.</p>
    <p>2. Booking is non-transferable and valid for only one Confirmation Voucher (CV). Cancellation and refund policy
      of
      the hotel booked will apply.</p>
    <p>3. Please carry the Confirmation Voucher with you to the hotel / resort and present it at the time of checking in
      along with your photo identity card-this will enable us to honour the reservation confirmation.</p>
    <p>4. The standard check-in and check-out time vary from hotel to hotel. Early check-in or late check-out is
      strictly
      subjected to availability and may be chargeable by the hotel. Any early check-in or late check-out request must be
      directed and reconfirmed with hotel directly.</p>
    <p>5. The age of the primary guest must be at least 18 years old to be able to check into the hotel.</p>
    <p>6. Signature Stays rates do not include additional personal expenses like telephone charges, meals that aren't
      part
      of the meal plan, any hotel services partner uses (like laundry and room service) or tips. The hotel will charge
      User directly for these when he is checking out.</p>
    <p>7. It is mandatory for guests to present valid photo identification at the time of check-in. According to
      government regulations, a valid Photo ID has to be carried by every person above the age of 18 staying at the
      hotel.
      The identification proofs accepted are Driver’s License, Voters Card, and Passport (passport mandatory for
      International Holidays). Without valid ID the guest will not be allowed to check in. Note: PAN Cards will not be
      accepted as a valid ID card.</p>
    <p>8. Hotels reserve the right of admission. Unmarried/unrelated couples may not be allowed to check-in in some
      hotels. Similarly, In some hotels, accommodation can be denied to guests posing as a 'couple' if suitable proof of
      identification is not presented at check-in. CC will not be responsible for any check-in denied by the hotel due
      to
      the aforesaid reason. No refund would be applicable in case the hotel denies check-in under such circumstances.
    </p>
    <p>9. Hotels may collect certain taxes or levies directly at the time of check in. All additional charges (including
      mandatory meal surcharges) need to be cleared directly at the hotel by the User.</p>
    <p>10. Please note that it takes minimum of 4 to 8 working hours to confirm a reservation at the hotel for same day
      check-ins.</p>
    <p>11. Some Hotels may not allow local residents as guests to check-in. This is strictly subjected to the Hotel
      Policies and CC will not be responsible for such check-in denials.</p>
    <p>12. Hotel rules and regulations including check in time, etc. apply accordingly.</p>
    <p>13. Any additional costs beyond that provided clearly to the User would need to be settled by the guest on check
      out at the hotel.</p>



    <b>CURATED DEALS</b>

    <p>1. Definitions</p>
    <p>Merchants/Stores/Retailers are the eCommerce apps where you are transacting, and they deliver the
      products/services
      to you. They give us a commission/payout/referral fee for valid transactions (as tracked through them or via the
      affiliate ad networks) and we share most of that commission as cashback with Affiliate Ad networks are the
      networks
      like Optimise, Admitad, Cuelinks, DCM, icubeswire and others one who enables tracking for completed transactions
      with the eCommerce stores.</p>
    <p>2. Our Service Introduction</p>
    <p>vivo XClub App enables registered users to be able to get savings in the form of discounts / cashbacks on
      transactions completed on online retailers/merchants' apps or on their mobile apps where tracking is enabled
      (currently Amazon, Flipkart, Snapdeal, ShopClues & many more). In addition to these discounts / cashbacks, we also
      provide information about other offers/sales/discounts/deals/coupon codes from merchants/stores as well as from
      Banks for online transactions. We also provide you information about prices of products in many categories for
      some
      of the top stores like Flipkart, Snapdeal, Amazon, ShopClues, and many more. The prices are the ones that we
      obtain
      using our automated software crawlers/scrapers from the eCommerce apps or via the price/product feeds sent by the
      e-commerce apps directly or through affiliate ad networks. While it is our best effort to keep the prices listed
      on
      our apps up to date, however, the eCommerce apps may change their prices more often than we can update our prices,
      and thus there sometimes be a difference in prices listed on our app and the eCommerce app as well as differences
      in
      the prices on their apps and their mobile apps, however, you will always be able to see the most updated price on
      the eCommerce apps once you are redirected there. We will enable an intelligent comparison of offers by enabling
      you
      to see the best combination of offers.</p>
    <p>3. Your membership Information</p>
    <p>
      We enable registration for our service on the mobile app using a phone number. We can only provide vivo XClub App
      cashbacks in the form of Flipkart Gift Vouchers and Paytm Recharge/Bill Payments/Movie Tickets Cashbacks in the
      form
      of Paytm Cash. You must be above 18 years of age to be able to use our mobile app. Important: You must ensure that
      you use the correct information (email address, mobile number, etc.) to register for the service. We only allow
      one
      account per person (we use multiple criteria to qualify unique users like email address, mobile number, serial
      number for mobile app amongst other criteria) and change in email address & phone number is not permitted, hence
      you
      must ensure that you have access to the email address that you use to register for the service. In case you lose
      access to this email address in the future, you will have to register for the service again and will not be able
      to
      avail yourself of the vivo XClub App cashbacks in your previous account.
    </p>
    <p>4. Cashback, Price Comparison, and Other Offers</p>
    <p>When you complete a valid transaction at one of our partner eCommerce apps (either online or through their mobile
      browser or mobile application) (PS: Only a few partners like Flipkart, ShopClues give commissions for Mobile app
      transactions) and once we receive the payout/commission from them for such valid and tracked transactions, then
      part
      of this will be passed to you as cashback as per the cashback amount that was communicated on our App as per the
      payout given to us by the eCommerce app. A valid transaction is defined as one where a registered user was logged
      in
      and checked out and completed a transaction on one of our partner apps and if a coupon code was used then it was
      from our app (Bank Offers which we mention on our app may not qualify for vivo XClub App cashbacks). Please note
      that whether or not a transaction shall qualify as a valid transaction for Cashback is completely at the sole
      discretion of the Store or vivo XClub App and our customers have to understand and agree to the same. vivo XClub
      App
      cannot be held responsible if the stores or the store's network fail to report a sale to us or does not qualify a
      transaction as a valid Transaction for cashback. Also, vivo XClub App cannot be held responsible in the event due
      to
      some technical, network, or other error we cannot trace a sale back to our customer and do not qualify the
      transaction as a valid transaction for cashback for any reason whatsoever. Please note that tracking does not work
      effectively on the mobile for such transactions for mobile web to mobile web or mobile app redirection and thus we
      cannot be held responsible if you transacted on the mobile web version of our app or the mobile app and the
      Cashback
      did not track as several merchants/stores have not yet enabled mobile tracking on their mobile apps / mobile
      browsers. However, we will on best effort basis only try to display those offers on our mobile app where mobile
      tracking has been enabled by the stores.</p>
    <p>5. Missing Reward Enquiries and Requests</p>
    <p>If your vivo XClub App has not tracked in pending status within 72 hours or has tracked at a lower amount, then
      you
      may be able to raise a missing vivo XClub App Reward request but only up to 10 days from the date of your
      transaction as merchants will not answer any queries about tracking vivo XClub App Rewards/Paytm Cashbacks in
      pending status after 10 days of transacting. While we will make our best efforts in following up with the
      merchants
      to track your vivo XClub App Rewards/Paytm Cashbacks, however, the decision of the merchants/stores is final and
      binding. We also reserve the right to close any missing vivo XClub App Rewards/Paytm Cashbacks claim requests if
      so,
      required especially if no purchase has been made or purchase has been canceled. We shall not be liable for any
      rejected cashback claims or where the amount tracked is lower than expected. The process for tracking missing
      Rewards requests is that our system will only allow the customer to enter a request for the stores where a click
      id
      was generated when the customer clicked out from our App to that store. We save all such Clickout ID's in our
      database for being able to cross-reference vivo XClub App Rewards/Paytm Cashbacks amounts and such queries, thus
      if
      the customer did not click out from our App then they would not be able to raise a missing cashback request for
      such
      transactions. Also, most stores will not allow us to raise queries about transactions where the cashback payout
      has
      been declined by them or where the amount is different from what the customer expected. We will try our best to
      raise such queries with the stores but cannot be held responsible if the stores do not support such queries. If
      the
      stores do not respond to a particular query for more than 6 months, then we may reserve the right to close such
      tickets. We may be required to make balance adjustments sometimes for Rewards amounts and reserve the right to be
      able to do so when we may have given the credit in error or otherwise (whether when the Reward was not genuinely
      due
      or when we do not receive the payment from the store or their network/agency for misuse/fraud or other reasons).
    </p>
    <p>7. vivo XClub App Role</p>
    <p>vivo XClub App is only a price comparison portal and mobile app which aggregates prices, discounts, offers &
      coupons. vivo XClub App offers Rewards to consumers is given out of the commission that is shared by
      retailers/merchants/stores for completed and valid transactions and we are not involved in selling/supplying the
      actual goods or services and are thus free from any liability, warranty or legal obligations that may apply to the
      sellers of those goods and services. Thus please note that we are not responsible for any of the below: - The
      quality, merchantability, safety, or legality of goods and services supplied by partner
      apps/stores/merchants/retailers- Whether or not the retailers deliver the goods or services to customers as we
      will
      only get information from the stores- If price changes happen often on the retailer's apps and are not updated on
      our App - If the retailers refuse to give the commission for transactions completed by customers as per reasons
      described above- If stores/banks gave an offer directly or through the affiliate networks which are invalid before
      their expiry, our customer's must exercise caution while transacting online with retailers/stores. You will
      release
      us and our agents from all claims or liability arising out of any of the above issues.
    </p>
    <p>8. Your Conduct</p>
    <p>You, the customer must not use the Mobile Application in any way that causes or is likely to cause, the App or
      access to it to be interrupted, damaged, or impaired in any way. You understand that you, and not the mobile app,
      are responsible for all electronic communications and content sent from your computer to us and you must use the
      App
      for lawful purposes only. You must not use the App for any of the following:</p>
    <p>a. For fraudulent purposes, or in connection with a criminal offense or other unlawful activity.</p>
    <p>b. To send, use or reuse any material that does not belong to you; or is illegal, offensive (including but not
      limited to material that is sexually explicit content or which promotes racism, bigotry, hatred, or physical
      harm),
      deceptive, misleading, abusive, indecent, harassing, blasphemous, defamatory, libelous, obscene, pornographic,
      pedophilic or menacing; ethnically objectionable, disparaging or in breach of copyright, trademark,
      confidentiality,
      privacy or any other proprietary information or right; or is otherwise injurious to third parties, or relates to
      or
      promotes money laundering or gambling; or is harmful to minors in any way; or impersonates another person; or
      threatens the unity, integrity, security or sovereignty of India or friendly relations with foreign States; or
      objectionable or otherwise unlawful in any manner whatsoever; or which consists of or contains software viruses,
      political campaigning, commercial solicitation, chain letters, mass mailings or any "spam".</p>
    <p>c. To cause annoyance, inconvenience, or needless anxiety.</p>

    <p>9. Copyright and Trademarks</p>
    <p>Everything located on this App is the exclusive property of the vivo XClub App or used with the express
      permission
      of the copyright and/or trademark owner. Any copying, distributing, transmitting, posting, linking, deep linking,
      or
      otherwise modifying of this app or any of the microapps without the express written permission of the vivo XClub
      App, is strictly prohibited. Any violation of this policy may result in a copyright, trademark, or other
      intellectual property right infringement that may subject the End User to civil and/or criminal penalties.
    </p>
    <p>This App contains copyrighted material, trademarks, and other proprietary information, including, but not limited
      to, text, software, photos, video, graphics, music, and sound, and the entire contents of the App are protected by
      copyright as a collective work under the United States copyright laws. vivo XClub App owns a copyright in the
      selection, coordination, arrangement, and enhancement of such content, as well as in the content original to it.
      End-User may not modify, publish, transmit, participate in the transfer or sale, create derivative works, or in
      any
      way exploit any of the content, in whole or in part. End-User may download, print, and/or save copyrighted
      material
      for the End User's personal use only. Except as otherwise expressly stated under copyright law, no copying,
      redistribution, retransmission, publication, or commercial exploitation of downloaded material without the express
      permission of the vivo XClub App or the copyright owner is permitted. If copying, redistribution, or publication
      of
      copyrighted material is permitted, no changes in or deletion of author attribution, trademark legend, or copyright
      notice shall be made. End-User acknowledges that he/she/it does not acquire any ownership rights by downloading
      copyrighted material. Trademarks that are located within or on the App or otherwise owned or operated in
      conjunction
      with vivo XClub App shall not be deemed to be in the public domain but rather the exclusive property of vivo XClub
      App unless such app is under license from the trademark owner thereof, in which case such license is for the
      exclusive benefit and use of Vivo XClub App unless otherwise stated.</p>
    <p>End-User shall not upload, post, or otherwise make available on this App any material protected by copyright,
      trademark, or other proprietary rights without the express permission of the owner of the copyright, trademark, or
      other proprietary rights. vivo XClub App does not have any express burden or responsibility to provide End User
      with
      indications, markings, or anything else that may aid End User in determining whether the material in question is
      copyrighted or trademarked. End-User shall be solely liable for any damage resulting from any infringement of
      copyrights, trademarks, proprietary rights, or any other harm resulting from such a submission. By submitting
      material to any public area of this App, the End User warrants that the owner of such material has expressly
      granted
      vivo XClub App the royalty-free, perpetual, irrevocable, non-exclusive right and license to use, reproduce,
      modify,
      adapt, publish, translate and distribute such material (in whole or in part) worldwide and/or to incorporate it in
      other works in any form, media or technology now known or hereafter developed for the full term of any copyright
      that may exist in such material. End-User also permits vivo XClub to access, view and store, or reproduce the
      material for that End User's personal use. End-User hereby grants the right to edit, copy, publish and distribute
      any material made available on this App by End User.</p>
    <p>The foregoing provisions of Section 5 apply equally to and are for the benefit of vivo XClub App, its
      subsidiaries,
      affiliates, Merchants, and its third-party content providers and licensors and each shall have the right to assert
      and enforce such provisions directly or on its behalf.
    </p>
    <p>10. Copyright Policy</p>
    <p>vivo XClub App reserves the right to terminate its agreement with any End User who repeatedly infringes
      third-party
      copyright rights upon prompt notification to vivo XClub App by the copyright owner or the copyright owner's legal
      agent. Without limiting the foregoing, if you believe that a copyrighted work has been copied and posted via the
      App
      in a way that constitutes copyright infringement, you shall provide vivo XClub App with the following information:
      (a) an electronic or physical signature of the person authorized to act on behalf of the owner of the copyrighted
      work; (b) identification and location on the App of the copyrighted work that you claim has been infringed; (c) a
      written statement by you that you have a good faith belief that the disputed use is not authorized by the owner,
      its
      agent, or the law; (d) your name and contact information, such as telephone number or e-mail address; and (e) a
      statement by you that the above information in your notice is accurate and, under penalty of perjury, that you are
      the copyright owner or authorized to act on the copyright owner's behalf. Contact information for vivo XClub App
      Copyright Agent for notice of claims of copyright infringement is as follows:</p>
    <p>Club Concierge Services (India) Private Limited,</p>
    <p>#83 7th Cross 4th B Block Koramangala Bangalore 560034</p>
    <p>vivosupport&#64;concierges.in</p>

    <p>11. Disclaimer of Warranty</p>
    <p>The end-user expressly agrees that the use of this app is at the end user's sole risk. Neither vivo XClub App,
      its
      affiliates nor any of their respective employees, agents, merchants, third-party content providers or licensors,
      or
      any of their officers, directors, employees, or agents, warrant that use of the app will be uninterrupted or
      error-free; nor do they make any warranty as to (i) the results that may be obtained from the use of this app, or
      (ii) the accuracy, reliability or content of any information, service or vouchers provided through this app.</p>
    <p>This App is made accessible on an "as is" and "as available" basis. vivo XClub App hereby disclaims any
      representations, warranties, and conditions, whether express or implied, including, but not limited to, those of
      title non-infringement, merchantability, and fitness for a particular purpose.</p>
    <p>The Merchant, not the vivo XClub App, is the maker, and in most cases, the fulfiller, of the Product and is
      solely
      responsible for the Product and its performance.</p>

    <p>12. Limitation of Liability</p>
    <p>In no event shall vivo XClub App, be liable for any indirect, incidental, special, consequential, or punitive
      damages arising out of or related to this agreement. In no event will vivo XClub App liability in connection with
      a
      vivo XClub App exceed the amounts paid for such vivo XClub App, and total aggregate liability arising out of or
      related to this agreement shall not exceed the amounts paid by the end-user during the six months preceding the
      bringing of any claim.</p>

    <p>13. Monitoring</p>
    <p>vivo XClub App shall have the right, but not the obligation, to monitor the content of the App at all times,
      including any chat rooms and forums that may hereinafter be included as part of the App, to determine compliance
      with this Agreement and any operating rules established by vivo XClub App, as well as to satisfy any applicable
      law,
      regulation or authorized government request. Without limiting the foregoing, vivo XClub App shall have the right,
      but not the obligation, to remove any material that vivo XClub App, in its sole discretion, finds to violate the
      provisions hereof or otherwise objectionable.</p>

    <p>14. Privacy</p>
    <p>End-User acknowledges that all discussions for ratings, comments, bulletin board service, chat rooms, and/or
      other
      message or communication facilities (collectively "Communities") are public and not private communications, and
      that, therefore, others may read End User's communications without End User's knowledge. vivo XClub App does not
      control or endorse the content, messages, or information found in any Community, and, therefore, vivo XClub App
      specifically disclaims any liability concerning the Communities and any actions resulting from End Users'
      participation in any Community, including any objectionable content. Generally, any communication that which End
      User posts (whether in chat rooms, discussion groups, message boards, or otherwise) is considered to be
      non-confidential. If particular web pages permit the submission of communications that will be treated by the vivo
      XClub App as confidential, that fact will be stated on those pages. By posting comments, messages, or other
      information on the App, the End User grants vivo XClub App the right to use such comments, messages, or
      information
      for promotions, advertising, market research, or any other lawful purpose without territorial, time or other
      limitation. For more information see the vivo XClub App Privacy Policy.</p>

    <p>15. License Grant</p>
    <p>By posting communications on or through this App, the End User shall be deemed to have granted to vivo XClub App
      a
      royalty-free, perpetual, irrevocable, non-exclusive license to use, reproduce, modify, publish, edit, translate,
      distribute, perform, and display the communication alone or as part of other works in any form, media, or
      technology
      whether now known or hereafter developed without territorial or time limitations, and to sublicense such rights
      through multiple tiers of sublicenses.</p>

    <p>16. Indemnification/Release</p>
    <p>End-User agrees to defend, indemnify and hold harmless vivo XClub App, its affiliates, and their respective
      directors, officers, employees, and agents from and against all claims and expenses, including attorneys' fees,
      arising out of or related to any products or services purchased by End User in connection with the App.</p>
    <p>The end-user is solely responsible for interactions with Merchants and other users of the App or Apps. To the
      extent permitted under applicable laws, End User hereby releases vivo XClub App from any claims or liability
      related
      to any product or service of a Merchant, any action or inaction by Merchant, including Merchant's failure to
      comply
      with applicable law and/or failure to abide by the terms of a Voucher, and any conduct or speech, whether online
      or
      offline, of any other user.</p>
    <p>In connection with the foregoing release, End User hereby waives any provision in any jurisdiction which states:
      "A
      general release does not extend to claims which the creditor does not know or suspect to exist in his favor at the
      time of executing the release, which, if known by him must have materially affected his settlement with the
      debtor."
    </p>

    <p>17. Termination</p>
    <p>Vivo XClub App may terminate this Agreement at any time. Without limiting the foregoing, vivo XClub App shall
      have
      the right to immediately terminate or suspend any passwords or accounts of End User in the event of any conduct by
      End User or which vivo XClub App, in its sole discretion, considers to be unacceptable, or in the event of any
      breach by End User of this Agreement. The provisions of Sections 2, 4, 5, 6, 7, 10, 11, and 12 will survive the
      termination of this Agreement.</p>

    <p>18. Trademarks</p>
    <p>vivo XClub App is a trademark of vivo India Pvt. Ltd. All rights in respect of this trademark are hereby
      expressly
      reserved. Unless otherwise indicated, all other trademarks appearing on vivo XClub App are the property of their
      respective owners</p>

    <p>19. Third-Party Content</p>
    <p>vivo XClub App, similar to an Internet Service Provider, is a distributor (and not a publisher) of content
      supplied
      by third parties and End Users. Accordingly, the vivo XClub App Test has no more editorial control over such
      content
      than does a public library, bookstore, or newsstand. Any opinions, advice, statements, services, offers, or other
      information or content expressed or made available by third parties, including information providers, or any other
      end users are those of the respective author(s) or distributor(s) and not of vivo XClub App.</p>
    <p>In many instances, the content available through this App represents the opinions and judgments of the respective
      information provider, end-user, or other users not under contract with the vivo XClub App. vivo XClub App neither
      endorses nor is responsible for the accuracy or reliability of any opinion, advice, or statement made on vivo
      XClub
      App by anyone other than authorized Vivo XClub App employee spokespersons while acting in official capacities.
      Under
      no circumstances will vivo XClub App be liable for any loss or damage caused by an end user's reliance on
      information obtained through vivo XClub App. It is the responsibility of the End User to evaluate the accuracy,
      completeness, or usefulness of any information, opinion, advice, etc., or other content available through the vivo
      XClub App.</p>
    <p>vivo XClub App contains links to third-party apps maintained by other content providers. These links are provided
      solely as a convenience to you and not as an endorsement by vivo XClub App of the contents on such third-party
      apps,
      and vivo XClub App hereby expressly disclaims any representations regarding the content or accuracy of materials
      on
      such third-party apps. If the End User decides to access linked third-party apps, the End User does so at its own
      risk. Unless you have executed a written agreement with vivo XClub App expressly permitting you to do so, you may
      not provide a hyperlink to the App from any other app. vivo XClub App reserves the right to revoke its consent to
      any link at any time in its sole discretion.</p>

    <p>20. Miscellaneous</p>
    <p>This Agreement, including the Terms of Sale, set forth below (which are incorporated into this Agreement), and
      any
      operating rules for vivo XClub App established by us, constitute the entire agreement of the parties concerning
      the
      subject matter hereof. No waiver by either party of any breach or default hereunder is a waiver of any preceding
      or
      subsequent breach or default. The section headings used herein are for convenience only and shall be of no legal
      force or effect. If any provision of this Agreement is held invalid by a court of competent jurisdiction, such
      invalidity shall not affect the enforceability of any other provisions contained in this Agreement, and the
      remaining portions of this Agreement shall continue in full force and effect. The failure of either party to
      exercise any of its rights under this Agreement shall not be deemed a waiver or forfeiture of such rights or any
      other rights provided hereunder.</p>

    <p>21. Arbitration</p>
    <p>By using this App, End User agrees that: (1) any claim, dispute, or controversy End User may have against vivo
      XClub App arising out of, relating to, or connected in any way with this Agreement, this App, or the purchase or
      sale of any Voucher(s), shall be resolved exclusively by final and binding arbitration administered by and
      conducted
      before a single arbitrator pursuant to the applicable Rules and Procedures established by the laws of India (2)
      the
      arbitration shall be held at Bengaluru, India pursuant to the law of India or at such other location as may be
      mutually agreed upon by End User and vivo XClub App; (3) the arbitrator shall apply the Indian law and applicable
      statutes of limitations, and shall honor claims of privilege recognized at law; (4) there shall be no authority
      for
      any claims to be arbitrated on a class or representative basis; arbitration can decide only the End User's and/or
      vivo XClub App individual claims; and the arbitrator may not consolidate or join the claims of other persons or
      parties who may be similarly situated; (5) in the event that the End User is able to demonstrate that the costs of
      arbitration will be prohibitive as compared to the costs of litigation, Service Provider will pay as much of the
      End
      User's filing and hearing fees in connection with the arbitration as the arbitrator deems necessary to prevent the
      arbitration from being cost-prohibitive; and (6) with the exception of subpart (4) above, if any part of this
      arbitration provision is deemed to be invalid, unenforceable or illegal, or otherwise conflicts with the Rules and
      Procedures established by the Bengaluru courts, then the balance of this arbitration provision shall remain in
      effect and shall be construed in accordance with its terms as if the invalid, unenforceable, illegal or
      conflicting
      provision were not contained herein. If, however, subpart (4) is found to be invalid, unenforceable, or illegal,
      then the entirety of this Arbitration Provision shall be null and void, and neither End User nor vivo XClub App
      shall be entitled to arbitrate their dispute. </p>

    <p>22. Disclosures</p>
    <p>You should note that parental control protections (such as computer hardware, software, or filtering services)
      are
      commercially available that may assist you in limiting access to material that is harmful to minors.
    </p>
    <b>
      XTRAORINARY BIRTHDAY </b>
    <p>1. Customers can only avail the EazyDiner Prime membership in their birthday month only, with a validity of 4
      months from the date of enrolment. </p>
    <p>2. The Payeazy coupon worth INR 300 will be added to your gift card section in your EazyDiner profile. This code
      can be used during the payment at all Payeazy enabled restaurants across India subject to a minimum billing of INR
      500.</p>
    <p>3. Members can avail of additional benefits offered by banks while paying through respective bank card. These
      benefits are over and above the restaurant discounts available.</p>
    <p>4. The Payeazy gift coupons cannot be combined with bank offers. </p>
    <p>5. The banking partners and offers are subject to change by EazyDiner management</p>
    <p>6. Prime membership purchased under any campaign cannot be cancelled or refunded.</p>
    <p>7. The EazyDiner Prime deal will be clearly identified on the restaurant screen. All EazyDiner Prime deals will
      have a minimum of 25% discount as specified in the deal.</p>
    <p>8. Not all restaurants bookable on EazyDiner will have prime deals. Some restaurants may also have non-prime
      deals.
      All discounts are mentioned clearly against each deal for all restaurants bookable on EazyDiner.</p>
    <p>9. The restaurants and the offers are dynamic as we constantly improve the product, hence the offers at
      restaurants
      may change without any prior notice. In case there are any concerns, please call the EazyDiner Prime hotline at
      786
      100 4400.</p>
    <p>
      10. All 1+1 deals are valid for a minimum of 2 guests. Example - In case of 3 guests, 2 guests will be charged,
      and
      1 guest will eat for free, in case of 5 guests, 3 guests will be charged, and 2 guests will eat for free.
    </p>
    <p>11. Please inform the restaurant about your reservation through EazyDiner upon your arrival at the restaurant to
      have a hassle-free experience.</p>
    <p>12. EazyDiner shall not be liable for the experience at the partner restaurant as we only assist in fulfilling
      the
      reservations with the special offers.</p>
    <p>13. EazyDiner shall not be liable if any restaurant is temporarily or permanently shut. In case there are any
      concerns, please call the EazyDiner Prime hotline at 786 100 4400.</p>
    <p>14. The highlighted savings of Rs.3000 are for a table of 4 and on a blended average in over 2000+ premium
      restaurants. These savings may vary depending on the number of people dining per table and the average cost per
      diner.</p>
    <p>15. The Prime membership fee cannot be encashed</p>
    <p>16. For recurring Prime memberships, once the subscription is charged, no refund of subscription money will take
      place. You can switch off auto-renewal of your recurring prime membership.</p>
    <p>
      17. No wallet cash can be used to purchase the membership.
    </p>
    <p>18. Other terms and conditions apply. To view, please visit the EazyDiner website.</p>
  </div>

</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-button (click)="dismiss()" expand="block">
      I AGREE
    </ion-button>
  </ion-toolbar>
</ion-footer>